import { useTranslation } from 'react-i18next';

import { CrossPlatformSection } from '../components/home/cross-platform-section';
import { DevelopersTeaser } from '../components/home/developers-teaser';
import { FeatureBentoSection } from '../components/home/feature-bento-section';
import { FinalCtaSection } from '../components/home/final-cta-section';
import { HeroSection } from '../components/home/hero-section';
import { usePageMeta } from '../lib/use-page-meta';

export function HomePage() {
  const { t } = useTranslation('marketing');

  usePageMeta(t('home.meta.title'), t('home.meta.description'));

  return (
    <>
      <HeroSection />
      <FeatureBentoSection />
      <CrossPlatformSection />
      <DevelopersTeaser />
      <FinalCtaSection />
    </>
  );
}
